import { useMutation, useQuery } from 'react-query'

import { timezoneService } from '@/modules/profile-settings/service/timezone-service.ts'
import { handleError } from '@/utils/error'

export function useTimezones() {
  const { data } = useQuery(
    'available-timezones',
    timezoneService.getAvailableTimezones,
    {
      onError: (error) =>
        handleError(error, 'Failed to get available timezones'),
    },
  )
  const setTimezone = useMutation('set-timezone', timezoneService.setTimezone, {
    onError: (error) => handleError(error, 'Failed to set timezone'),
  })

  return {
    timezones: data,
    setTimezone,
  }
}
